import { useState } from 'react';
import { getString } from '../../../strings';
import TournamentsCompetitions from '../../molecules/Tournaments/TournamentsCompetitions';

import { StyledText } from '../../atoms/Text/StyledText';
import { StyledPlayerElementDataWrapper } from '../../atoms/Tournament/StyledPlayerElementDataWrapper';
import { StyledPlayerElement } from '../../atoms/Tournament/StyledPlayerElement';
import { StyledPlayerAvatar } from '../../atoms/Tournament/StyledPlayerAvatar';

import { ReactComponent as AvatarIcon } from '../../../images/register/avatarIcon.svg';

import FsLightbox from 'fslightbox-react';

import countries from 'i18n-iso-countries';
import { StyledSavePayElement } from '../../atoms/PayElement/StyledSavePayElement';
import AcceptIcon from '../../atoms/UserPanelStudens/AcceptIcon';
import { getRegisterStatus } from '../../../logic/requests/events';
import CloseIcon from '../../atoms/UserPanelStudens/CloseIcon';
import { StyledClosePayElement } from '../../../styles/sharedStyles';
import AcceptCompetitorPopup from './Components/AcceptCompetitorPopup';
import RemoveAvatarPopup from './Components/RemoveAvatarPopup';
import useWindowSize from '../../../utils/getWindowSize';
countries.registerLocale(require('i18n-iso-countries/langs/pl.json'));

const PlayerElement = ({ canManageAllEvents, playerData, eventId }) => {
    const wca_href = playerData?.wca_id
        ? `https://www.worldcubeassociation.org/persons/${playerData.wca_id}`
        : null;

    const [isOpenAcceptCompetitorPopup, setIsOpenAcceptCompetitorPopup] = useState(false);
    const [isOpenRemoveAvatarPopup, setIsOpenRemoveAvatarPopup] = useState(false);
    const [toggler, setToggler] = useState(false);

    const canBeConfirmed =
        playerData?.reserve === 0 &&
        (playerData?.register_status !== getRegisterStatus('CONFIRMED') ||
            (playerData?.register_status === getRegisterStatus('CONFIRMED') && !playerData?.free));
    const canOnlyBeMarkedAsFree =
        playerData?.register_status === getRegisterStatus('CONFIRMED') && !playerData?.free;
    const hasAvatar = playerData?.has_avatar;

    const width = useWindowSize();
    const isLargeScreen = width >= 1300;
    const centerButtons = width > 767 && width < 1300;

    return (
        <StyledPlayerElement>
            <StyledPlayerAvatar issend={false}>
                {playerData?.has_avatar ? (
                    <div style={{ cursor: 'pointer' }}>
                        <img
                            src={`/api/users/get-avatar/${playerData?.id}`}
                            alt=""
                            onClick={() => setToggler(!toggler)}
                            width="100%"
                            height="100%"
                            style={{
                                objectFit: 'cover',
                            }}
                        />
                        <FsLightbox
                            toggler={toggler}
                            sources={[`/api/users/get-avatar/${playerData?.id}`]}
                        />
                    </div>
                ) : (
                    <AvatarIcon />
                )}
            </StyledPlayerAvatar>
            <StyledPlayerElementDataWrapper hasdeclaredwidth={canManageAllEvents ? '25%' : '40%'}>
                {wca_href ? (
                    <>
                        <a
                            aria-label={getString('seo_aria_label_przejdz_do_strony')}
                            href={wca_href}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <StyledText
                                hasdeclaredfontsize="16px"
                                hasdeclaredfontweight="600"
                                hasdeclaredtexttransform="uppercase"
                                hasdeclaredfontcolor={playerData?.wca_id ? '#3D5CA2' : '#EE745C'}
                                hascursor="pointer"
                            >
                                {getString('tournament_playerElement_zawodnik')}
                            </StyledText>
                        </a>
                        <a
                            aria-label={getString('seo_aria_label_przejdz_do_strony')}
                            href={wca_href}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <StyledText
                                hasdeclaredfontsize="16px"
                                hasdeclaredfontweight="600"
                                hasdeclaredpadding="5px 0"
                                hascursor="pointer"
                            >
                                {playerData.firstname} {playerData.lastname}
                            </StyledText>
                        </a>
                    </>
                ) : (
                    <>
                        <StyledText
                            hasdeclaredfontsize="16px"
                            hasdeclaredfontweight="600"
                            hasdeclaredtexttransform="uppercase"
                            hasdeclaredfontcolor={playerData?.wca_id ? '#6786be' : '#EE745C'}
                        >
                            {getString('tournament_playerElement_zawodnik2')}
                        </StyledText>
                        <StyledText
                            hasdeclaredfontsize="16px"
                            hasdeclaredfontweight="600"
                            hasdeclaredpadding="5px 0"
                        >
                            {playerData.firstname} {playerData.lastname}
                        </StyledText>
                    </>
                )}
            </StyledPlayerElementDataWrapper>
            <StyledPlayerElementDataWrapper hasdeclaredwidth={canManageAllEvents ? '25%' : '30%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtexttransform="uppercase"
                    hasdeclaredfontcolor="#6786be"
                >
                    {getString('tournament_playerElement_miejscowosc')}
                </StyledText>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredpadding="5px 0"
                >
                    {playerData.city ? `${playerData.city}, ` : null}
                    {countries.getName(playerData.country, 'pl')}
                </StyledText>
            </StyledPlayerElementDataWrapper>
            <StyledPlayerElementDataWrapper hasdeclaredwidth={canManageAllEvents ? '20%' : '30%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtexttransform="uppercase"
                    hasdeclaredfontcolor="#6786be"
                >
                    {getString('tournament_playerElement_konkurencje')}
                </StyledText>
                <TournamentsCompetitions
                    competitions={playerData.competitions}
                    size="17px"
                    hasdeclaredmargin="3px 2px 0 -1px"
                />
            </StyledPlayerElementDataWrapper>
            {canManageAllEvents ? (
                <StyledPlayerElementDataWrapper
                    $flexDirection="row"
                    hasdeclaredwidth={isLargeScreen ? '9%' : '100%'}
                    style={{ gap: 5, justifyContent: centerButtons ? 'center' : '' }}
                >
                    {canBeConfirmed ? (
                        <StyledSavePayElement
                            style={{
                                transform: 'translateY(0)',
                                minWidth: '40px',
                                minHeight: '40px',
                            }}
                            $isDisabled={!canBeConfirmed}
                            disabled={!canBeConfirmed}
                            onClick={() => setIsOpenAcceptCompetitorPopup(true)}
                            isedit
                        >
                            <AcceptIcon />
                        </StyledSavePayElement>
                    ) : null}
                    {hasAvatar ? (
                        <StyledClosePayElement
                            style={{
                                transform: 'translateY(0)',
                                minWidth: '40px',
                                minHeight: '40px',
                            }}
                            $disabled={!hasAvatar}
                            disabled={!hasAvatar}
                            onClick={() => setIsOpenRemoveAvatarPopup(true)}
                            isedit
                        >
                            <CloseIcon />
                        </StyledClosePayElement>
                    ) : null}
                </StyledPlayerElementDataWrapper>
            ) : null}
            {isOpenAcceptCompetitorPopup ? (
                <AcceptCompetitorPopup
                    player={playerData}
                    eventId={eventId}
                    canOnlyBeMarkedAsFree={canOnlyBeMarkedAsFree}
                    closePopup={() => setIsOpenAcceptCompetitorPopup(false)}
                />
            ) : null}
            {isOpenRemoveAvatarPopup ? (
                <RemoveAvatarPopup
                    player={playerData}
                    eventId={eventId}
                    closePopup={() => setIsOpenRemoveAvatarPopup(false)}
                />
            ) : null}
        </StyledPlayerElement>
    );
};

export default PlayerElement;
